<div class="wh-label">Working hours</div>

<div class="wh-cols">

  <!-- Mon – Fri -->
  <div class="wh-col">
    @for (day of WEEKDAYS; track day.key) {
      <div class="wh-row" [class.wh-row--closed]="!hours[day.key].open">
        <span class="wh-day">{{ day.label }}</span>
        <mat-slide-toggle
          [checked]="hours[day.key].open"
          [disabled]="disabled"
          (change)="toggleOpen(day.key, $event.checked)"
          color="primary">
        </mat-slide-toggle>
        @if (hours[day.key].open) {
          <div class="wh-times">
            <input class="wh-time" type="time"
              [value]="hours[day.key].from"
              [disabled]="disabled"
              (change)="setTime(day.key, 'from', $event)" />
            <span class="wh-sep">–</span>
            <input class="wh-time" type="time"
              [value]="hours[day.key].to"
              [disabled]="disabled"
              (change)="setTime(day.key, 'to', $event)" />
          </div>
        } @else {
          <span class="wh-closed">Closed</span>
        }
      </div>
    }
  </div>

  <!-- Sat – Sun -->
  <div class="wh-col wh-col--weekend">
    @for (day of WEEKEND; track day.key) {
      <div class="wh-row" [class.wh-row--closed]="!hours[day.key].open">
        <span class="wh-day">{{ day.label }}</span>
        <mat-slide-toggle
          [checked]="hours[day.key].open"
          [disabled]="disabled"
          (change)="toggleOpen(day.key, $event.checked)"
          color="primary">
        </mat-slide-toggle>
        @if (hours[day.key].open) {
          <div class="wh-times">
            <input class="wh-time" type="time"
              [value]="hours[day.key].from"
              [disabled]="disabled"
              (change)="setTime(day.key, 'from', $event)" />
            <span class="wh-sep">–</span>
            <input class="wh-time" type="time"
              [value]="hours[day.key].to"
              [disabled]="disabled"
              (change)="setTime(day.key, 'to', $event)" />
          </div>
        } @else {
          <span class="wh-closed">Closed</span>
        }
      </div>
    }
  </div>

</div>